/* iter413g — Global keyboard shortcut + drawer state for AI Radce.
 *
 * Cmd+I (macOS) / Ctrl+I (Win/Linux) toggles the AI Advisor drawer.
 * Esc closes it. Other components can call openAdvisor() to open it
 * programmatically.
 */
import { useState, useEffect, useCallback } from "react";

let _setOpen = null;  // singleton hook into the host component

export function openAdvisor(pageContext = null) {
  if (_setOpen) _setOpen({ open: true, pageContext });
}

export function useAIAdvisorShortcut() {
  const [state, setState] = useState({ open: false, pageContext: null });
  _setOpen = setState;

  const close = useCallback(() => setState((s) => ({ ...s, open: false })), []);
  const toggle = useCallback(
    (pageContext = null) =>
      setState((s) => (s.open ? { open: false, pageContext: null } : { open: true, pageContext })),
    []
  );

  useEffect(() => {
    function onKey(e) {
      // Cmd+I (macOS) or Ctrl+I (Win/Linux). Ignore inside form inputs unless modifier held.
      if ((e.metaKey || e.ctrlKey) && (e.key === "i" || e.key === "I")) {
        e.preventDefault();
        toggle();
      } else if (e.key === "Escape" && state.open) {
        // Don't close if user has any modal open — but we don't know about those here.
        close();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [toggle, close, state.open]);

  return { ...state, open: state.open, pageContext: state.pageContext, close, toggle };
}
